import React from 'react';
import {Table, TablePaginationConfig} from 'antd';
import type {ColumnsType, TableProps} from 'antd/es/table';
import {IngredientDataType, ingredientItem, ingredientsColumn} from '../models/column';

const data: IngredientDataType[] = [];
for (let i = 0; i < 100; i++) {
  data.push({...ingredientItem, id: i});
}

const CustomTable: React.FC<{
  columns?: ColumnsType<IngredientDataType>;
  dataSource?: IngredientDataType[];
  pagination?: false | TablePaginationConfig;
  loading?: boolean;
  onChange?: TableProps<IngredientDataType>['onChange'];
  rowKey?: TableProps<IngredientDataType>['rowKey'];
}> = ({
  columns = ingredientsColumn,
  dataSource = data,
  pagination = false,
  loading = false,
  onChange,
  rowKey,
}) => {
  return (
    <Table
      scroll={{y: 'calc(100vh - 330px)'}}
      columns={columns}
      dataSource={dataSource}
      pagination={pagination}
      loading={loading}
      onChange={onChange}
      rowKey={rowKey ?? 'id'}
    />
  );
};

export default CustomTable;
